import ActionComponentEntity from '../../entities/ActionComponentEntity'
import Repository from './Repository'

export default class ActionComponentRepository extends Repository {
  constructor(adapter) {
    super()
    this._adapter = adapter
  }

  addEntity(entity) {
    this.add(new ActionComponentEntity(entity))
  }

  getActionComponentById(actionComponentId) {
    let query = { actionComponentId: actionComponentId }
    return this.find(query)
  }

  addActionComponent(data) {
    this.add(new ActionComponentEntity(data))
  }

  async FetchAllActionComponentsByLevel(maxLevel, sortBy) {
    let result = await this._adapter.FetchAllActionComponentsByLevel(maxLevel)
    return this.processListResponse(result, sortBy)
  }

  _mapFetchedDataToEntity(fetchedData) {
    if (fetchedData === [] || fetchedData === undefined) {
      return
    }
    if (Array.isArray(fetchedData)) {
      fetchedData.map(data => this.add(new ActionComponentEntity(data)))
    } else {
      this.add(new ActionComponentEntity(fetchedData))
    }
    return
  }
  // _mapperIn(data = {}) {
  // 	const mappedData = { id: data.id, title: data.title, description: data.description,
  // 		status: data.status, level: data.level, playListURL: data.playListURL}
  // 	const masterClass = new MasterClass(mappedData)
  // 	this._data.push(masterClass)
  // }
}
